<portal-card>
  <!-- Entries header -->
  <ng-container header>
    <h2>{{ title }}</h2>
  </ng-container>

  <ng-container actions>
    <span>
      <span class="badge text-bg-primary">
        @if (mode === 'ADD_REMOVE') {
          {{ 'bulk.action.selected.total' | translate }}
        }
        {{
          'bulk.action.selectedTotal'
            | translate
              : {
                  selected: entries.length - bulkActionState.unchanged.length,
                  total: entries.length,
                }
        }}
      </span>
      @if (mode === 'ADD_REMOVE') {
        <span
          class="badge text-bg-success ms-2"
          [ngClass]="{ 'text-bg-light': bulkActionState.added.length === 0 }"
        >
          {{
            'bulk.action.selectedAdded'
              | translate
                : {
                    selected: bulkActionState.added.length,
                    total: entries.length - activeEntries.length,
                  }
          }}
        </span>
      }
      @if (mode === 'ADD_REMOVE') {
        <span
          class="badge text-bg-warning ms-2"
          [ngClass]="{ 'text-bg-light': bulkActionState.removed.length === 0 }"
        >
          {{
            'bulk.action.selectedRemoved'
              | translate
                : {
                    selected: bulkActionState.removed.length,
                    total: activeEntries.length,
                  }
          }}
        </span>
      }
    </span>
  </ng-container>

  <!-- Progress -->
  @if (entries.length > page.pageSize) {
    @if (processingActive > 0 || hasBeenProcessed) {
      <div class="progress mb-2">
        @if (processingSuccesses > 0) {
          <div class="progress-bar text-bg-success" [style]="progressSuccess">
            <span>{{ processingSuccesses }} <i class="far fa-check fa-fw ms-1"></i></span>
          </div>
        }
        @if (processingFailures > 0) {
          <div class="progress-bar text-bg-danger" [style]="progressFailure">
            <span>{{ processingFailures }} <i class="far fa-bolt fa-fw ms-1"></i></span>
          </div>
        }
      </div>
    }
  }

  <div class="bulk-action__filter mb-2">
    <!-- Filter bar -->
    <portal-filter-input
      class="filter__input-group"
      [calculateMetaData]="calculateMetaData"
      [entries]="bulkEntries"
      [properties]="properties"
      (changed)="updateEntries($event)"
    ></portal-filter-input>

    <div ngbDropdown>
      <button class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>
        {{ 'bulk.action.actions' | translate }}
      </button>
      <div class="dropdown-menu--bootstrap-default" aria-labelledby="dropdownBasic1" ngbDropdownMenu>
        <!-- Select all (enabled only if any item is unchanged) -->
        <button [disabled]="hasBeenProcessed === true" (click)="selectAll()" ngbDropdownItem>
          <i class="far fa-check-square"></i>

          {{
            (mode === 'ADD_REMOVE' ? 'bulk.action.selection.assignAll' : 'bulk.action.selection.all')
              | translate
          }}
        </button>

        <!-- Unselect all (enabled only if any item has changed) -->
        <button [disabled]="hasBeenProcessed === true" (click)="unselectAll()" ngbDropdownItem>
          <i class="far fa-square"></i>

          {{
            (mode === 'ADD_REMOVE' ? 'bulk.action.selection.removeAll' : 'bulk.action.selection.none')
              | translate
          }}
        </button>

        @if (filterIsActive) {
          <!-- Select all filtered (visible only if a filter is) (enabled only if any item is unchanged) -->
          <button [disabled]="hasBeenProcessed === true" (click)="selectAllFiltered()" ngbDropdownItem>
            <i class="far fa-check-square"></i>
            {{
              (mode === 'ADD_REMOVE'
                ? 'bulk.action.selection.assignAllFiltered'
                : 'bulk.action.selection.allFiltered'
              ) | translate
            }}
          </button>
          <!-- Unselect all filtered (enabled only if any item has changed) -->
          <button [disabled]="hasBeenProcessed === true" (click)="unselectAllFiltered()" ngbDropdownItem>
            <i class="far fa-square"></i>
            {{
              (mode === 'ADD_REMOVE'
                ? 'bulk.action.selection.removeAllFiltered'
                : 'bulk.action.selection.unselectFiltered'
              ) | translate
            }}
          </button>
        }

        <!-- Reset (enabled only if in ADD_REMOVE mode and any has changed) -->
        @if (mode === 'ADD_REMOVE') {
          <button
            [disabled]="
              (bulkActionState.added.length === 0 && bulkActionState.removed.length === 0) ||
              hasBeenProcessed === true
            "
            (click)="reset()"
            ngbDropdownItem
          >
            <i class="far fa-undo"></i>
            {{ 'bulk.action.selection.reset' | translate }}
          </button>
        }

        <!-- Divider -->
        @if (collapsible === true) {
          <div class="dropdown-divider"></div>
        }

        <!-- Expand all (visible only if the bodyTemplate is set) -->
        @if (collapsible === true) {
          <button (click)="collapsed = false" ngbDropdownItem>
            <i class="far fa-expand-arrows"></i>
            {{ 'bulk.action.expand.all.details' | translate }}
          </button>
        }

        <!-- Collapse all (visible only if the bodyTemplate is set) -->
        @if (collapsible === true) {
          <button (click)="collapsed = true" ngbDropdownItem>
            <i class="far fa-minus-square"></i>
            {{ 'bulk.action.collapse.all.details' | translate }}
          </button>
        }

        <!-- Divider (visible only if the filter isn't empty) -->
        @if (activeFilter) {
          <div class="dropdown-divider"></div>
        }

        <!-- Remove filter (visible only if the filter isn't empty) -->
        @if (activeFilter) {
          <button (click)="updateVisibleEntries()" ngbDropdownItem>
            <i class="far fa-times"></i>
            {{ 'bulk.action.filter.remove' | translate }}
          </button>
        }
      </div>
    </div>

    <portal-pagination
      class="filter__pagination"
      [page]="page"
      [simple]="true"
      (onPageChanged)="onPageChanged($event)"
    ></portal-pagination>
  </div>

  <div class="row">
    <div class="col d-flex justify-content-end">
      @if (hasBeenProcessed && processingActive === 0 && processingFailures > 0) {
        <div class="form-check me-2">
          <input
            class="form-check-input"
            id="showOnlyFailures"
            [(ngModel)]="showOnlyFailures"
            (change)="updateVisibleEntries()"
            type="checkbox"
          />
          <label class="form-check-label" for="showOnlyFailures">
            {{ 'bulk.action.showOnlyFailedEntries' | translate }}
          </label>
        </div>
      }

      <div class="form-check">
        <input
          class="form-check-input"
          id="showOnlyChanges"
          [(ngModel)]="showOnlyChanges"
          (change)="updateVisibleEntries()"
          type="checkbox"
        />
        <label class="form-check-label" for="showOnlyChanges">
          {{ 'bulk.action.filter.selected' | translate }}
        </label>
      </div>
    </div>
  </div>

  <div class="row">
    <!-- Entries -->
    @for (bulkActionEntry of pagedEntries; track bulkActionEntry) {
      <div class="col-md-6 col-12">
        <ng-container
          [ngTemplateOutlet]="template || defaultTemplate"
          [ngTemplateOutletContext]="{
            $implicit: bulkActionEntry.entry,
            bulkActionEntry: bulkActionEntry,
            collapsed: collapsed,
          }"
        ></ng-container>
      </div>
    }
  </div>

  <ng-template
    #defaultTemplate
    let-bulkActionEntry="bulkActionEntry"
    let-collapsed="collapsed"
    let-disabled="disabled"
  >
    <portal-default-bulk-action-entry
      [bodyTemplate]="bodyTemplate"
      [bulkActionEntry]="bulkActionEntry"
      [collapsed]="collapsed"
      [disabled]="hasBeenProcessed || processingActive > 0"
      [errorTemplate]="errorTemplate"
      [headerTemplate]="headerTemplate"
      (click)="toggleEntryState(bulkActionEntry)"
    ></portal-default-bulk-action-entry>
  </ng-template>

  <!-- Pagination -->
  <portal-pagination [page]="page" (onPageChanged)="onPageChanged($event)" footer></portal-pagination>

  <!-- Save bar (there is a component unsaved changes bar but we don't use it because the use case here is too specific) -->
  @if (anyEntryChanged || (processingFailures > 0 && replay)) {
    <div
      class="unsaved-changes-bar"
      [ngClass]="{ 'alert-warning': anyEntryChanged, 'alert-danger': processingFailures > 0 }"
    >
      <div class="d-flex align-items-center justify-content-between">
        <strong>
          <i class="far fa-exclamation-triangle fa-fw unsaved-changes-bar__title-icon"></i>
          <span class="unsaved-changes-bar__title">
            @if (anyEntryChanged && processingFailures === 0) {
              {{ 'general.form.unsaved.changes' | portalTranslate }}
            } @else {
              {{ 'bulk.actions.execution.failed' | translate }}
            }
          </span>
        </strong>
        <div class="unsaved-changes-bar__buttons">
          @if (hasBeenProcessed === false) {
            <button class="btn btn-link unsaved-changes-bar__button--reset" (click)="reset()" type="reset">
              {{ 'button.reset' | portalTranslate }}
            </button>
          }
          @if (hasBeenProcessed === false || processingActive > 0 || replay === true) {
            <button
              class="btn btn-primary"
              [disabled]="processingActive > 0"
              (click)="submit()"
              data-style="expand-right"
              type="submit"
            >
              @if (processingActive > 0) {
                <i class="far fa-fw fa-circle-notch fa-spin"></i>
              } @else {
                <i class="far fa-fw fa-check"></i>
              }
              <!-- We use a template because now we can use the else of the *ngIf directive and check just once for state -->
              @if (processingFailures === 0) {
                {{ mainActionText }}
              } @else {
                {{ 'bulk.actions.execution.repeat.on.failed' | translate }}
              }
            </button>
          }
        </div>
      </div>
    </div>
  }
</portal-card>
